import React from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import EuiRow from "../../eui-components/row";
import EuiTextField from "../../eui-components/textfield";
import ApiClient from "../../utils/api-client";
import WorkplanHelper from "../../utils/workplan-helper";
import { IconButton, Tooltip } from "@material-ui/core";


class WorkplanFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        }
    }

    handleChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;

        const filter = { ...this.props.workplanData.filter };
        filter[name] = value || "";
        this.props.setFilter(filter);
    }

    syncWorkplanWithErisite = () => {
        const filter = this.props.workplanData.filter ;
        const ErisiteWorkplanData = filter["erisiteWorkplanId"]
        const initialState = new Date();
        this.setState({ isLoading: true }, () => {
            ApiClient.post("Workplan/SyncErisiteWorkplanData", {ErisiteWorkplanId : ErisiteWorkplanData })
                .then(response => {
                    this.getWorkplans(1,30)
                })
                .catch(error => {
                    console.error(error);;
                    this.setState({ isLoading: false });
                });
        });
    }
      syncSiteTrackerByProjectName = () => {
        
        const filter = this.props.workplanData.filter ;
        const ErisiteWorkplanData = filter["siteTrackerProjectName"]
        const initialState = new Date();
        this.setState({ isLoading: true }, () => {
            ApiClient.post("Workplan/SyncSiteTrackerByProjectName", {siteTrackerProjectName : ErisiteWorkplanData })
                .then(response => {
                    this.getWorkplans(1,30,ErisiteWorkplanData)
                })
                .catch(error => {
                    console.error(error);;
                    this.setState({ isLoading: false });
                });
        });
    }
    getWorkplans = (page, pageSize,siteTrackerProjectName = null) => {
        const filter = {...this.props.workplanData.filter};


        delete filter["page"];
        delete filter["pageSize"];
    
        
        if (!filter || Object.values(filter).every(x => (!x || x === ""))) {
            toast.error("Please, fill any field to get related workplans", { containerId: "WS", position: toast.POSITION.TOP_CENTER });
            return;
        }

        const initialState = new Date();
        filter.page = page;
        filter.pageSize = pageSize;
        filter.id = parseInt(filter.id ?? "0");
        if(siteTrackerProjectName){
        filter.erisiteWorkplanId =  siteTrackerProjectName
        }
        else if(filter["siteTrackerProjectName"]) {
          filter.erisiteWorkplanId =  filter["siteTrackerProjectName"]
        }
         delete filter["siteTrackerProjectName"];
        this.setState({ isLoading: true }, () => {
            ApiClient.post("Workplan/GetFilteredWorkplans", filter)
                .then(response => {
                    this.props.setFilteredWorkplans({ searchedData: [], data: [], totalCount: 0 });
                    const data = [...response.data.data];
                    WorkplanHelper.mapWorkplans(data);

                    this.setState({ isLoading: false }, () => {
                        this.props.setFilteredWorkplans({ searchedData: data, data, totalCount: response.data.totalCount, initialState: initialState.getTime() });

                    });
                })
                .catch(error => {
                    console.error(error);;
                    this.setState({ isLoading: false });
                });
        });
    }

    render() {
        return (<EuiRow>

            <EuiTextField className="m-1 w-10" fullwidth id="workplanIdFilter" name="id" label="Workplan ID (=)"
                value={this.props.workplanData.filter.id || ""} onChange={(e) => this.handleChange(e)}
                //suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: {value:"", name: "id"}})}
            />

            <EuiTextField className="m-1 w-10 mb-0" fullwidth id="erisiteWorkplanIdFilter" name="erisiteWorkplanId" label="Erisite Workplan ID (=)"
                value={this.props.workplanData.filter.erisiteWorkplanId || ""} onChange={(e) => this.handleChange(e)}
                //    suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: { value: "", name: "erisiteWorkplanId" } })}
            />
            {/*this is for sync button*/}
            <div className="w-full" style={{
                position: 'relative',
                width: '100%' 
               
                
            }}>
                <Tooltip className="m-1 w-2" id="rotate" title="Sync Workplan from Erisite">
                    <button className={"btn cursor-pointer " + (this.state.isLoading ? "loading disabled" : "")} style={{
                        willChange: 'transform', color: "#0077db", border: "none", background: "none", textAlign: "right", position: 'absolute',
                        right:0 ,
                        width: '100%',
                        top: '-6px',
                        
                    }} id="syncworkplan" onClick={() => this.syncWorkplanWithErisite()}>Sync Erisite</button>
                </Tooltip>
            </div>
 <EuiTextField className="m-1 w-10 mt-5" fullwidth id="erisiteWorkplanIdFilter" name="siteTrackerProjectName" label="SiteTracker Project Name (=)"
                value={this.props.workplanData.filter.siteTrackerProjectName || ""} onChange={(e) => this.handleChange(e)}
                //    suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: { value: "", name: "siteTrackerProjectName" } })}
            />
            {/*this is for sync button Site Tracker*/}
            <div style={{
                position: 'relative', height: '0', marginBottom : '10',
                width: '100%'
            }}>
                <Tooltip className="m-1 w-2" id="rotate" title="Sync Project  from SiteTracker">
                    <button className={"btn cursor-pointer " + (this.state.isLoading ? "loading disabled" : "")} style={{
                        willChange: 'transform', color: "#0077db", border: "none", background: "none", textAlign: "right", position: 'absolute',
                        right: 0,
                        top: '-6px',
                        width: '100%',
                    }} id="syncworkplan" onClick={() => this.syncSiteTrackerByProjectName()}>Sync Sitetracker</button>
                </Tooltip>
            </div>
            <EuiTextField className="m-1 w-10 mt-5" fullwidth id="wpAssignmentIdFilter" name="wpAssignmentId" label="WP Assignment ID (=)"
                value={this.props.workplanData.filter.wpAssignmentId || ""} onChange={(e) => this.handleChange(e)}
                //suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: { value: "", name: "wpAssignmentId" } })}
            />
            <EuiTextField className="m-1 w-10" fullwidth id="workplanNameFilter" name="name" label="Workplan Name (*)"
                value={this.props.workplanData.filter.name || ""} onChange={(e) => this.handleChange(e)}
                //suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: { value: "", name: "name" } })}
            />
            <EuiTextField className="m-1 w-10" fullwidth id="customerSiteIdFilterWorkplan" name="customerSiteId" label="Customer Site ID (*)"
                value={this.props.workplanData.filter.customerSiteId || ""} onChange={(e) => this.handleChange(e)}
                //suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: { value: "", name: "customerSiteId" } })}
            />
            <EuiTextField className="m-1 w-10" fullwidth id="projectNameFilter" name="projectName" label="Project Name (*)"
                value={this.props.workplanData.filter.projectName || ""} onChange={(e) => this.handleChange(e)}
                //suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: { value: "", name: "projectName" } })}
            />
            <EuiTextField className="m-1 w-10" fullwidth id="siteNameFilter" name="siteName" label="Site Name (*)"
                value={this.props.workplanData.filter.siteName || ""} onChange={(e) => this.handleChange(e)}
                //suffix={<div className="suffix icon-inside"><i className="icon icon-filter"></i></div>}
                clear={true}
                onClear={() => this.handleChange({ target: { value: "", name: "siteName" } })}
            />
            <button className={"btn primary m-1 " + (this.state.isLoading ? "loading disabled" : "")} onClick={() => this.getWorkplans(1, 30)}>Search</button>
        </EuiRow >);
    }
}

const mapStateToProps = state => ({ userData: state.user, navbarData: state.navigation, workplanData: state.workplan });
const mapDispatchToProps = dispatch => {
    return {
        setFilteredWorkplans: (filteredWorkplans) => dispatch({ type: "SET_FILTERED_WORKPLANS", payload: filteredWorkplans }),
        setFilter: (filter) => dispatch({ type: "SET_FILTER", payload: filter }),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WorkplanFilter); 